import React from 'react';

import { useTranslation } from 'react-i18next';

import { ButtonSizeVariants, ButtonVariants } from 'constants/common';
import { DatabaseColumn } from 'interfaces/report-configuration.interface';
import { Button } from 'shared-components';

import TableItemsList from './TableItemsList';

interface SelectedColumnsPanelProps {
  tableName: string;
  columns: DatabaseColumn[];
  selectedColumns: DatabaseColumn[];
  onToggleColumn: (column: DatabaseColumn) => void;
  onSave: () => void;
  onCancel: () => void;
}

const AvailableTableItemBlock: React.FC<SelectedColumnsPanelProps> = ({
  tableName,
  columns,
  selectedColumns,
  onToggleColumn,
  onSave,
  onCancel,
}) => {
  const { t } = useTranslation();

  if (!tableName) {
    return null;
  }

  const isSelected = (columnName: string) =>
    selectedColumns.some((col) => col.name === columnName && col.tableName === tableName);

  return (
    <div className="border border-neutral-200 dark:border-neutral-800 rounded-lg px-5 pb-2.5 h-[65vh] md:w-1/2 mt-5 md:mt-0 overflow-y-auto">
      <div className="flex justify-between items-center sticky top-0 bg-white dark:bg-black-900 py-2">
        <p className="text-sm">{tableName}</p>
        <div className="flex gap-2">
          <Button
            onClick={onCancel}
            dataCy="modal-close-button"
            variant={ButtonVariants.OUTLINE}
            size={ButtonSizeVariants.SM}
          >
            {t('Cancel')}
          </Button>
          <Button onClick={onSave} dataCy="modal-close-button" size={ButtonSizeVariants.SM}>
            {t('Save')}
          </Button>
        </div>
      </div>

      <TableItemsList items={columns} isSelected={(item) => isSelected(item.name)} onToggleColumn={onToggleColumn} />
    </div>
  );
};

export default AvailableTableItemBlock;
